import React from 'react'
import { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService'

export default class AuthorizeRoute extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false,
            loggedIn: false
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    render() {
        const { ready, authenticated, loggedIn } = this.state;
        var link = document.createElement("a");
        link.href = this.props.path;
        const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
        const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`
        if (!ready) {
            return <div></div>;
        } else {
            const { component: Component, ...rest } = this.props;
            return <Route {...rest}
                render={(props) => {
                    if (authenticated) {
                        return <Component {...props} />
                    } else if (loggedIn) {
                        return <h3>You are unauthorized to view this page.</h3>
                    } else {
                        return <Redirect to={redirectUrl} />
                    }
                }} />
        }
    }

    //this role logic would be better in login?
    async populateAuthenticationState() {
        var loggedIn = await authService.isAuthenticated();
        var authenticated = false;
        var rolesString = this.props.roles;
        var userRolesString = await authService.getRole();
        if (rolesString && userRolesString) {
            var userRoles = userRolesString.split(",");
            var roles = rolesString.split(",");
            for (var i = 0; i < roles.length; i++) {
                var role = roles[i].trim();
                for (var ii = 0; ii < userRoles.length; ii++) {
                    var userRole = userRoles[ii];
                    if (role === userRole) {
                        authenticated = true;
                        break;
                    }
                }
                if (authenticated) { break; }
            }
        }
        this.setState({ ready: true, authenticated, loggedIn });
    }

    async authenticationChanged() {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }
}
